import { html, unsafeCSS } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { property } from 'lit/decorators.js';
import { ButtonType, ButtonVariant } from './enum';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './button.styles';

export class Button extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: String }) label?: string;

    @property({ type: String, reflect: true })
    variant: ButtonVariant = ButtonVariant.Primary;

    @property({ type: String, reflect: true })
    type: ButtonType = ButtonType.Button;

    @property({ type: Boolean })
    disabled = false;

    @property({ type: String })
    icon?: string;

    @property({ type: String, attribute: 'icon-position' })
    iconPosition: 'before' | 'after' = 'before';

    @property({ type: String })
    url?: string;

    @property({ type: Boolean, attribute: 'wrap-text' })
    wrapText?: boolean = false;

    @property({ type: String })
    subtitle?: string;

    onSubmitClick(event: Event): void {
        const form = this.closest('form');
        if (form && this.type === ButtonType.Submit) {
            event.preventDefault();
            const fakeSubmit = document.createElement('button');
            fakeSubmit.type = 'submit';
            fakeSubmit.style.display = 'none';
            form.appendChild(fakeSubmit);
            fakeSubmit.click();
            fakeSubmit.remove();
        }
    }

    override render() {
        const content = html`
            ${this.icon && this.iconPosition === 'before' ? html`<i class="c-button__icon">${this.icon}</i>` : ''}
            <div class="c-button__content">
                <span class="c-button__label"><slot>${this.label}</slot></span>
                ${this.subtitle ? html`<span class="c-button__subtitle">${this.subtitle}</span>` : ''}
            </div>
            ${this.icon && this.iconPosition === 'after' ? html`<i class="c-button__icon">${this.icon}</i>` : ''}
        `;

        return this.url
            ? html`
                  <a
                      href="${this.url}"
                      class=${classMap({
                          'c-button': true,
                          'c-button__wrap-text': !!this.wrapText,
                      })}
                      data-button-style-variant="${this.variant}"
                      >${content}</a
                  >
              `
            : html`
                  <button
                      .disabled=${this.disabled}
                      class=${classMap({
                          'c-button': true,
                          'c-button__wrap-text': !!this.wrapText,
                      })}
                      data-button-style-variant="${this.variant}"
                      @click=${this.onSubmitClick}
                      aria-label=${this.label || 'Button'}
                  >
                      ${content}
                  </button>
              `;
    }
}
